import { useLocation } from 'react-router'
import { useExperimentManager } from 'services/ExperimentManager/ExperimentManager'
import { HOME_URL } from 'config/config'
import useScreenSize from 'hooks/useScreenSize'

export default function useMultiProductHomePageExperiment() {
  const experimentManager = useExperimentManager()
  const isMobile = !useScreenSize('md')
  const { pathname } = useLocation()

  if (isMobile) {
    return { isEnabled: true }
  }

  // Gate the experiment exposure on the homepage so the population only includes visitors who see
  // it; the side menu, mounted on every page, reads this hook too.
  const isOnHomepage = pathname === HOME_URL
  return {
    isEnabled:
      isOnHomepage &&
      experimentManager.isEnabled('multi-product-homepage-desktop'),
  }
}
